module.exports = __webpack_public_path__ + "img/About_Employers_LIGHT-04.8d16f7e.svg";